"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestBitbucket = exports.requestJira = exports.requestConfluence = void 0;
const bridge_1 = require("../bridge");
const fetch_1 = require("./fetch");
_a = (0, fetch_1.productFetchApi)((0, bridge_1.getCallBridge)()), exports.requestConfluence = _a.requestConfluence, exports.requestJira = _a.requestJira, exports.requestBitbucket = _a.requestBitbucket;
